/* eslint-disable camelcase */
import { NotificationType, UserPreferences } from "@asd/customer-portal-api";

export type UserPreferenceRow = {
  label: string;
};

const USER_PREFERENCE_DEFINITIONS: Record<keyof UserPreferences, UserPreferenceRow> = {
  passwordExpirationNotification: { label: "Password Expiration" },
  monthlyServicesNotification: { label: "Monthly Services Summary" },
  infoUpdateNotification: { label: "Info Update Reminders" },
};

const PREFERENCES_BY_ROLE: Record<string, (keyof UserPreferences)[]> = {
  participant: ["passwordExpirationNotification", "monthlyServicesNotification"],
  provider: ["passwordExpirationNotification", "infoUpdateNotification"],
  case_manager: ["passwordExpirationNotification", "monthlyServicesNotification"],
  program_admin: ["passwordExpirationNotification"],
  global_admin: ["passwordExpirationNotification"],
};

export const getPreferenceRows = ({ roles }: { roles: string[] }): Array<{ key: keyof UserPreferences; label: string }> => {
  const match = Object.keys(PREFERENCES_BY_ROLE).find((role) => roles.includes(role));
  const keys = match ? PREFERENCES_BY_ROLE[match] : [];
  return keys.map((key) => ({ key, label: USER_PREFERENCE_DEFINITIONS[key].label }));
};

export const toNotificationType = (sms: boolean, email: boolean): NotificationType => {
  if (sms && email) return NotificationType.ALL;
  if (sms) return NotificationType.SMS;
  if (email) return NotificationType.EMAIL;
  return NotificationType.NONE;
};

export const fromNotificationType = (value: NotificationType): { sms: boolean; email: boolean } => {
  return {
    sms: value === NotificationType.SMS || value === NotificationType.ALL,
    email: value === NotificationType.EMAIL || value === NotificationType.ALL,
  };
};
